export const ERRORS_ROUTE_DATA = {
    BASE_PATH: 'error/',
    AUTHENTICATION_ERROR: {
        PATH: 'authentication-error',
        TITLE: 'Authentication Error',
    },
    FORBIDDEN: {
        PATH: 'forbidden',
        TITLE: 'Forbidden',
    },
    NOT_FOUND: {
        PATH: 'not-found',
        TITLE: 'Not Found',
    },
    SERVER_ERROR: {
        PATH: 'server-error',
        TITLE: 'Server Error',
    },
    UNAUTHORIZED: {
        PATH: 'unauthorized',
        TITLE: 'Unauthorized',
    },
};
